/**
 * VehicleExaminationDetails
 * Handles all JS stuff for vehicle examination detail page
 */
export default class VehicleExaminationDetails {

    // constructor
    constructor(selector) {

        let _this = this;
        this.$plugin = $(selector);

        // cancel if non existing element
        if (this.$plugin.length === 0) {
            return false;
        }

        this.$result = this.$plugin.find('[data-tncp-vehicleexaminationslist="results"]');
        if (this.$result.length > 0) {
            this.getResults();

            // on form submit
            this.$plugin.on('submit', '[data-tncp-vehicleexaminationslist="filterForm"]', () => {
                this.$plugin.find('[data-tncp-pagination-value]').val(''); // resets the pagination on filter change
                this.getResults(); // load results
                return false;
            });
        }

        this.contactForm();
        $('html').on('click', '[data-examinationcontactform-examination-id]', function() {

            // set values for modal
            $('[data-examinationcontactform-title-val]').html($(this).data('examinationcontactform-examination-id'));
            $('[data-examinationcontactform-examinationy-id-val]').val($(this).data('examinationcontactform-examination-id'));
            $('[data-examinationcontactform-examination-type-val]').val($(this).data('examinationcontactform-examination-type'));
            // initial behaviour on link clicking for modal
            $(document).find('[data-facilitycontactform-section="form"]').show();
            $(document).find('[data-facilitycontactform-section="success"]').hide();
            $(document).find('[data-facilitycontactform-section="error"]').hide();
            $(document).find('[name="tx_tuevnordcustomerportal_api[message]"]').val('');
        });
    }

    // get results
    getResults() {
        let vm = this;
        let $form = this.$plugin.find('[data-tncp-vehicleexaminationslist="filterForm"]');
        let serializedFilters = btoa($form.serialize());
        const formData = new FormData();
        return new Promise(function(resolve, reject) {
            formData.append("tx_tuevnordcustomerportal_api[filter]", serializedFilters);

            vm.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'true');

            vm.request = window.xhrRequest({
                url: $form.attr('action'),
                method: 'POST',
                data: formData
            });
            vm.request.then((response) => {
                vm.$result.html(response.data.content);
            vm.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'false');

                resolve(response);
            });
            vm.request.catch((e) => {
                reject(e);
            });
        });
    }

    // on contactform submit
    contactForm() {
        let vm = this;
        vm.$plugin.find('#modal_examinationcontactform form').submit(function(event) {
            const $formEl = $(this);
            let serializedData = $formEl.serialize();
            $formEl.find('[data-examinationcontactform-section="error"]').hide();
            vm.disableForm($formEl);
            vm.request = window.xhrRequest({
                url: $formEl.attr('action'),
                method: 'POST',
                data: serializedData
            });
            vm.request.then(() => {
                $formEl.find('[data-examinationcontactform-section="success"]').show();
                $formEl.find('[data-examinationcontactform-section="form"]').hide();
            }).catch((e) =>{
                $formEl.find('[data-examinationcontactform-section="error"]').show();

            }).then(() => {
                vm.disableForm($formEl, false);
            });
            event.preventDefault();
        });
    }

    // disable all form fields
    disableForm($form, disable = true) {
        let $selectors = $form.find('button, input, select, textarea');
        if (disable === true) {
            $selectors.attr('disabled', true);
        } else {
            $selectors.removeAttr('disabled');
        }
    }

    // synchronize values and submit ob change
    synchronizeValues(selector) {
        let vm = this;
        $(selector).change(function() { // listen on change of selector
            let $vm = $(this); // this jquery obj
            $(selector).val($vm.val()); // seems weird, but changes the values of all form elements with the same selector
            vm.getResults();
        });
    }
}